export default __webpack_public_path__ + "static/media/htmlcss.14c3065e.svg";